<template>
	<v-app>
		<NavView>
		</NavView>	
		<v-main app>
			<div class="menu">
				<v-container><v-row class="menu-row">
					<v-col v-for="(item, index) in menus" :key="index" cols="6" sm="4" md="3" lg="2">
						<v-hover v-slot="{ hover }">
							<v-card class="mx-auto menus" :elevation="hover ? 12 : 2"
								:class="{ 'on-hover': hover }" @click="changePage(item.url)">
								<img :src="item.icon" />
								<span>{{ item.name }}</span>
							</v-card>
						</v-hover>
					</v-col>
				</v-row>
			</v-container>
			</div>
           <div class="message">
				<v-container>
					<v-row>
					<v-col cols="12" sm="6" md="4" lg="2">
						<v-card style="padding: 10px;">
							<v-card-title>系统通知</v-card-title>
							<v-card-text>								
								<p>暂时只使用报价功能，其他功能后期根据情况再作安排启用。</p>
								<p>经过初期使用，2026年8月进行了二期更新。增加微信登陆，完善移动端访问体验。</p>
							</v-card-text>
						</v-card>
					</v-col>
					<v-col cols="12" sm="6" md="4" lg="4" class="help-card">
						<v-card style="padding: 10px;">
							<v-card-title class="collapse-title" @click="helpCollapsed = !helpCollapsed">
								<span>系统使用说明</span>
								<v-icon class="collapse-icon">{{ helpCollapsed ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
							</v-card-title>
							<v-expand-transition>
								<v-card-text v-show="!helpCollapsed">
								<p>1、注册：
									系统只接受邀请注册，联系我们的采购可以获得注册邀请码。注册成功后可以绑定微信，通过微信登陆系统。一个账号只能绑定一个微信。
								</p>
								<p>
									2、报价：点击首页面板的“报价”或者左上角的弹出菜单，可以查询我司的询价，可以供货的可以给我司报价。点击“我的报价”可以查看自己所有的报价记录。
								</p>
								<p>
									3、订单：点击首页的“订单”或者左上角的弹出菜单，可以查询你跟我司的订单记录，点击对应的订单可以添加物流信息，发便我司查看物料的物流信息。
								</p>
								<p>
									4、系统管理：拥有系统管理权限的用户，点击左上角的弹出菜单“系统管理”，可以进入系统管理界面增加删除客户，可以设置用户的角色。
								</p>
							</v-card-text>
							</v-expand-transition>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
			</div>
		</v-main>
	</v-app>
</template>

<script>
	import NavView from "./../components/NavBar";
	export default {
		name: 'indexView',
		components: {
			NavView,
		},
		props: {
			msg: String
		},
		data() {
			return {
				value: 10,
				BufferValue: 20,
				interval: 0,
				menus: [
					{ name: '报价记录', icon: require('./../assets/s-bj.png'), url: '/quotation' },
					{ name: '订单记录', icon: require('./../assets/s-qr.png'), url: '/order' },
					{ name: '送货记录', icon: require('./../assets/s-sh.png'), url: '/order?tabId=1' },
					{ name: '对账记录', icon: require('./../assets/s-dz.png'), url: '/order?tabId=2' },
					{ name: '发票记录', icon: require('./../assets/s-fp.png'), url: '/order?tabId=3' },
				],
				helpCollapsed: true,
			}
		},
		methods: {
			changePage(url) {
				this.$router.push({
					path: url
				});
			}
		}
	}
</script>

<style>
	.menu {
		padding: 0 8px;
	}

	.menus {
		padding: 20px 10px;
		margin: 8px;
		text-align: center;
		cursor: pointer;
	}

	.menus>img {
		display: block;
		width: 40px;
		height: auto;
		margin: 0 auto 8px;
	}

	.menus>span {
		display: block;
		font-size: 14px;
		line-height: 1.2;
	}

	.v-card {
		transition: opacity .4s ease-in-out;
	}

	/* 桌面端保留 hover 效果，触屏(手机)直接全不透明 */
	.v-card:not(.on-hover) {
		opacity: 0.8;
	}

	@media (max-width: 600px) {
		.v-card:not(.on-hover) {
			opacity: 1;
		}

		.menus {
			padding: 16px 8px;
			margin: 6px;
		}

		.menus>img {
			width: 36px;
			margin-bottom: 6px;
		}

		.menus>span {
			font-size: 13px;
		}
	}

	.message {
		margin: 10px;
	}

	.collapse-title {
		display: flex;
		align-items: center;
		justify-content: space-between;
		cursor: pointer;
		user-select: none;
	}

	.collapse-icon {
		font-size: 20px;
		transition: transform .3s;
	}

	@media (max-width: 600px) {
		.message {
			margin: 10px 4px;
		}

		.message .v-card {
			padding: 8px 14px !important;
		}

		.message .v-card__title {
			font-size: 16px;
			padding: 12px 0 4px;
		}

		.message .v-card__text {
			font-size: 13px;
			line-height: 1.7;
		}
	}

	a {
		text-decoration-line: none;
	}
</style>
